import React from 'react';
import { withTranslation } from 'react-i18next';
import { Switch, FormControlLabel } from '@mui/material';
import { CheckCircle, Cancel } from '@mui/icons-material';
import { SparaVerticalCard, SparaHorizontalCard } from 'components/SparaOfferCard/SparaOfferCard';
import styles from './Step4.module.scss';

class Step4 extends React.Component {
    constructor(props) {
        super(props);
        this.store = JSON.parse(localStorage.getItem('user'));
        this.isAdmin = !!(
            this.store &&
            this.store.permission &&
            this.store.permission.includes('offer-create')
        );

        this.state = {
            approved: props.offerData?.approved || false,
        };
    }

    sendState() {
        return this.state;
    }

    isValidated() {
        return true;
    }

    render() {
        const { offerData, t } = this.props;
        const { approved } = this.state;

        return (
            <div className={styles.container}>
                <h4 className={styles.sectionTitle}>{t('app_preview')}</h4>
                <p className={styles.sectionDesc}>{t('app_preview_desc')}</p>

                <div className={styles.previewRow}>
                    <div className={styles.previewCol}>
                        <span className={styles.previewCardLabel}>{t('vertical_card')}</span>
                        <SparaVerticalCard offer={offerData} />
                    </div>
                    <div className={styles.previewColWide}>
                        <span className={styles.previewCardLabel}>{t('horizontal_card')}</span>
                        <SparaHorizontalCard offer={offerData} />
                    </div>
                </div>

                {(this.props.isAdmin || this.isAdmin) && (
                    <>
                        <h4 className={styles.sectionTitle} style={{ marginTop: 32 }}>{t('approval')}</h4>
                        <div
                            className={styles.approvedBar}
                            style={{
                                backgroundColor: approved
                                    ? 'var(--spara-success-soft, #e8f5e9)'
                                    : 'var(--spara-warning-bg, #fff3e0)',
                                border: `2px solid ${approved ? '#4caf50' : '#ff9800'}`,
                            }}
                        >
                            <div className={styles.approvedBarLeft}>
                                {approved ? (
                                    <CheckCircle style={{ color: '#4caf50', fontSize: 22 }} />
                                ) : (
                                    <Cancel style={{ color: '#ff9800', fontSize: 22 }} />
                                )}
                                <span
                                    className={styles.approvedBarLabel}
                                    style={{
                                        color: approved
                                            ? 'var(--spara-success-text, #2e7d32)'
                                            : 'var(--spara-warning-text-strong, #e65100)',
                                    }}
                                >
                                    {approved ? t('approved') : t('not_approved')}
                                </span>
                            </div>
                            <FormControlLabel
                                style={{ margin: 0 }}
                                control={
                                    <Switch
                                        checked={!!approved}
                                        onChange={(e) => this.setState({ approved: e.target.checked })}
                                        color="success"
                                    />
                                }
                                label=""
                            />
                        </div>
                    </>
                )}
            </div>
        );
    }
}

export default withTranslation('', { withRef: true })(Step4);
